import { connect } from 'react-redux';
import * as R from 'ramda';

import { Dispatch, IAppState } from '../../state';
import { ISearchEngineResultsPageDispatchProps, ISearchEngineResultsPageProps, SearchEngineResultsPage } from './index';

import { isInSerpLightGroup } from '../../../utils/experiments/audienceSerpLight';
import { setLoading } from '../../../filters/state/search';
import { setKeyPushNotificationValue } from '../../../serp/state/push_subscribed';
import { EHideOfferState, setHideOfferState } from '../../../serp/state/hide_offer';
import { FOfferType, offerTypeFromJsonQuery } from '../../../utils/category';
import { IJsonQueryType } from '../../../repositories/common/json_query';
import { INewbuildingGkButtonState } from '../../../filters/components/filters/ab/newbuilding_gk_button';
import { getTotalPagesCount } from '../../../utils/pagination';
import { canShowTrap } from './helpers';
import { isExperimentActive } from '../../../api/experiments';
import { isRedesignExperimentEnabled } from '../../../selectors/isRedesignExperimentEnabled';
import { isFiltersRedesignExperimentEnabled } from '../../../selectors/isFiltersRedesignExperimentEnabled';
import { setOffersScrolledToTop } from '../../../serp/state/coworking_experiments/coworkingAdModalMini';
import { isOfficeRentSearch } from '../../../utils/isOfficeRentSearch';
import { selectIsProfessionalSearchPromoVariant3Visible } from '../../../selectors/selectIsProfessionalSearchPromoVariant3Visible';

export const isNewbuildingFiltersExperiment = (state: INewbuildingGkButtonState) => {
  const EXPERIMENT_NAME = 'newbuilding-serp-filters';
  const RIGHT_OFFER_TYPES = [4];
  let isRightOfferType = false;

  let dealType: IJsonQueryType;
  let offerType: FOfferType;

  const { experiments, filters } = state;

  const experiment = experiments.find(experiment => experiment.name === EXPERIMENT_NAME);
  const experimentGroup = experiment ? Number(experiment.abGroup) : 0;

  if (experimentGroup === 0) {
    return false;
  }

  const { jsonQuery } = filters;

  if (jsonQuery) {
    dealType = jsonQuery._type;
    offerType = offerTypeFromJsonQuery(filters.jsonQuery);

    if (dealType && dealType === 'flatsale' && offerType && RIGHT_OFFER_TYPES.includes(offerType)) {
      isRightOfferType = true;
    }
  }

  return isRightOfferType;
};

/* istanbul ignore next */
export const mapStateToProps = (state: IAppState) => {
  const { config, results } = state;

  const { aggregatedOffers, offers, quickLinks, seo, totalOffers, jsonQuery } = results;

  /**
   * Нужно для эксперимента с микроразметкой
   * ---------------------------------------
   */
  const currencyVariant = {
    1: 'USD',
    2: 'RUB',
    3: 'EUR',
  };

  const currency =
    jsonQuery.currency && jsonQuery.currency.value
      ? currencyVariant[jsonQuery.currency.value]
      : /**
         * По умолчанию RUB
         */
        currencyVariant[2];

  //Эксперимент баннер перед бесконечной выдачей CD-44294
  const page = (jsonQuery.page && jsonQuery.page.value) || 1;
  const perPage = Number(config.get('serp.offersPerPage'));
  const totalPages = getTotalPagesCount(perPage, aggregatedOffers);
  const showPreInfinteSaveSearchBanner =
    Boolean(state.results.offers.length) && (totalPages === 1 || page === totalPages);
  const isOfferInSavedSearch = R.pathOr(undefined, ['results', 'jsonQuery', 'saved_search_id'], state);

  /* istanbul ignore next */
  return {
    currency,
    isPromotionMobileClosed: state.isPromotionMobileClosed,
    deviceType: state.deviceType,
    baseUrl: state.config.get<string>('apiBaseUrl') || '',
    lkUrl: state.config.get<string>('hiddenObjects.lkUrl') || '',
    isPrintEnabled: state.print.enabled,
    isFetching: state.isFetching,
    aggregatedOffers,
    offers,
    quickLinks,
    seo,
    subdomain: state.currentSubdomain,
    totalOffers,
    makeRequest: state.makeRequest,

    regions: state.filters.regions,
    currentLocation: state.filters.currentLocation,
    jsonQuery,
    /* istanbul ignore next */
    tags: state.filters.backup ? state.filters.backup.tags : state.filters.tags,

    user: state.user,
    isAdvancedModalVisible: state.isAdvancedModalVisible,
    isDirectionsModalVisible: state.filters.directionsModal.isVisible,
    isDistrictModalVisible: state.isDistrictModalVisible,
    isLocationSwitcherVisible: state.filters.locationSwitcher.isLocationSwitcherOpened,
    isMapModalVisible: state.isMapModalVisible,
    isStalkerBannerShown: state.isStalkerBannerShown,
    isMetroModalVisible: state.isMetroModalVisible,
    isOfficeCalculatorVisible: state.isOfficeCalculatorVisible,
    isSignInTriggerModalOpen: state.isSignInTriggerModalOpen,
    isTopPopupOpened: state.hideOffer.isTopPopupOpened,
    showTrap: canShowTrap(offers),
    hideOfferState: state.hideOffer.hideOfferState,
    hideOfferErrorMessage: state.hideOffer.hideOfferErrorMessage,
    isCommercialSurveyWidgetModalOpen: state.isCommercialSurveyWidgetModalOpen,

    httpApi: state.httpApi,
    queryString: state.results.queryString,

    isNewbuildingFiltersExperiment: isNewbuildingFiltersExperiment(state),
    isCardVisibilityObservationExperiment: isExperimentActive(state.experiments, 'card_visibility_observation'),

    context: {
      logger: state.logger,
    },
    showPreInfinteSaveSearchBanner,

    currentUrl: state.filters.jsonQueryUrl,
    isLightView: isInSerpLightGroup(state),
    isOfferInSavedSearch,
    isPromoCollectionsEnabled: state.isPromoCollectionsEnabled && page === 1,
    config: state.config,
    isRedesignEnabled: isRedesignExperimentEnabled(state),
    isFiltersRedesignEnabled: isFiltersRedesignExperimentEnabled(state),
    isCoworkingExperimentsEnabled: state.isCoworkingExperimentsEnabled && isOfficeRentSearch(state.filters.jsonQuery),
    isProfessionalSearchPromoEnabled: selectIsProfessionalSearchPromoVariant3Visible(state),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  setKeyPushNotificationValue: (value: boolean) => dispatch(setKeyPushNotificationValue(value)),
  setHideOfferState: (hideOfferState: EHideOfferState) => dispatch(setHideOfferState(hideOfferState)),
  setLoading: () => dispatch(setLoading()),
  onOffersScrollsToTop: () => dispatch(setOffersScrolledToTop()),
});

export const SearchEngineResultsPageContainer = connect<
  ISearchEngineResultsPageProps,
  ISearchEngineResultsPageDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(SearchEngineResultsPage);
